angular.module('smartorg.r6.mgmts.archivePortfolioFrom', []);
require('./archive-portfolio-from-existing-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.archivePortfolioFrom';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/archive-portfolio-from-existing/app/js/plumbing/app.js